import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5h12","key":"svg-0"}],["path",{"d":"M6 9h12","key":"svg-1"}],["path",{"d":"M12 9v10","key":"svg-2"}]]

/**
 * IconCurrencyTenge
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktdGVuZ2UiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNWgxMiIgLz4KICA8cGF0aCBkPSJNNiA5aDEyIiAvPgogIDxwYXRoIGQ9Ik0xMiA5djEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-tenge
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyTenge = createReactComponent('outline', 'currency-tenge', 'CurrencyTenge', __iconNode);

export default IconCurrencyTenge;